// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__Gs3uq","CenterTitleDiv":"styles_CenterTitleDiv__kq9T0","ScrollDownDiv":"styles_ScrollDownDiv__-Gdi3"};